{
  "title": "如何回覆餐飲宴會與使用客服",
  "description": "在活動頁回覆午餐與宴會、查看公告，並向主辦單位的服務台送出案件。",
  "headings": [
    "你會完成什麼",
    "適用角色",
    "操作前確認",
    "操作步驟",
    "完成後",
    "常見問題"
  ],
  "summary": "完成後，主辦單位會收到您的午餐與宴會回覆（僅作人數估算），遇到問題時您也能送出案件並追蹤處理狀態。",
  "roleNote": "活動參與者；餐飲回覆與客服需先登入",
  "prerequisites": [
    "已登入的帳號",
    "餐飲回覆需在截止前完成，以頁面顯示為準（TAAI 2026 為 2026/11/16 23:59，UTC+08:00）"
  ],
  "pathLabel": "活動頁 → 我的服務 → 餐飲與宴會／客服與協助（/events/:slug/meals、/events/:slug/help）",
  "steps": [
    {
      "title": "1. 回覆午餐與飲食需求",
      "description": "進入「餐飲與宴會」，勾選要出席午餐的日期，選擇飲食類別（無特殊需求、蛋奶素、純素、清真、不吃牛、不吃豬、海鮮過敏、堅果過敏、其他），需要時在補充說明填寫最多 200 字，按「儲存」。頁面會顯示距離截止的倒數，截止後無法再修改。備註以加密儲存，驗票人員與一般使用者都看不到。"
    },
    {
      "title": "2. 回覆宴會出席",
      "description": "在同一頁選擇「我會出席宴會」或「我不出席宴會」並儲存。這個回覆只供主辦單位估算人數，不是宴會資格也不是付款證明；宴會資格以官方 TAAI 報名為準。"
    },
    {
      "title": "3. 閱讀公告",
      "description": "活動頁的「最新公告」依重要程度標示為一般、重要或緊急，並有中英文版本。公告只是頁面上的資訊，主辦單位另可對持有接駁預約的人寄 Email 通知。"
    },
    {
      "title": "4. 向服務台送出案件",
      "description": "進入「客服與協助」，選擇類別（交通接駁、餐飲、報名、無障礙協助、遺失物、其他），填寫主旨與說明；若事情緊急請勾選「緊急」。按「送出案件」後可在「我的案件」看到狀態：新案件、處理中、已解決、已結案。你只看得到自己的案件。人身安全的緊急狀況請直接撥打 119 或 110 並通知現場工作人員，不要等待案件處理。"
    }
  ],
  "afterward": [
    "活動頁的「我的行程摘要」會顯示餐飲與宴會已回覆",
    "案件狀態由主辦單位更新，你可隨時回到「我的案件」查看"
  ],
  "nextSteps": "接駁車請見「如何預約活動接駁車」。",
  "faq": [
    {
      "q": "回覆宴會代表我有宴會資格嗎？",
      "a": "沒有。此回覆只用於估算人數，資格以官方 TAAI 報名為準。"
    },
    {
      "q": "截止後想改飲食需求怎麼辦？",
      "a": "系統截止後不接受修改，請改以「客服與協助」送出案件說明，由主辦單位判斷能否處理。"
    },
    {
      "q": "我的飲食備註誰看得到？",
      "a": "備註加密儲存，只有活動 owner 或 manager 可匯出（匯出會留下稽核紀錄），主辦方儀表板只顯示各飲食類別的人數彙總。資料在活動結束後 30 天自動刪除。"
    }
  ],
  "figures": [
    {
      "name": "meals",
      "alt": "餐飲與宴會回覆：勾選午餐、飲食類別、宴會出席，截止前可修改",
      "caption": "餐飲與宴會回覆：勾選午餐、飲食類別、宴會出席，截止前可修改"
    },
    {
      "name": "help-desk",
      "alt": "客服與協助：選類別送出案件，並在「我的案件」看處理狀態",
      "caption": "客服與協助：選類別送出案件，並在「我的案件」看處理狀態"
    }
  ]
}
